import { useState } from 'react';

export const useContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  
  const [formStatus, setFormStatus] = useState({
    submitted: false,
    success: false,
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    
    // 表单验证
    if (!formData.name.trim() || !formData.email.trim() || !formData.message.trim()) {
      setFormStatus({
        submitted: true,
        success: false,
        message: '请填写所有必填字段'
      });
      return;
    }

    // 邮箱格式验证
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setFormStatus({
        submitted: true,
        success: false,
        message: '请输入有效的邮箱地址'
      });
      return;
    }

    // 显示发送中状态
    setFormStatus({
      submitted: true,
      success: false,
      message: '正在发送...'
    });

    try {
      // 调用后端API发送邮件
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      const response = await fetch(`${API_URL}/api/send-email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();

      if (result.success) {
        setFormStatus({
          submitted: true,
          success: true,
          message: result.message
        });

        // 清空表单
        setFormData({
          name: '',
          email: '',
          message: ''
        });
      } else {
        setFormStatus({
          submitted: true,
          success: false,
          message: result.message || '发送失败，请稍后重试'
        });
      }
    } catch (error) {
      console.error('发送邮件错误:', error);
      setFormStatus({
        submitted: true,
        success: false,
        message: '网络错误，请检查网络连接后重试'
      });
    }

    // 5秒后重置状态
    setTimeout(() => {
      setFormStatus({
        submitted: false,
        success: false,
        message: ''
      });
    }, 5000);
  };

  return {
    formData,
    formStatus,
    handleInputChange,
    handleFormSubmit
  };
}; 